import { mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
export default {
  name: 'SelectColor',
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  mounted() {
    // Create a Bootstrap modal.
    this.modal = jQuery(this.$refs.modal).modal({
      backdrop: 'static',
      focus: true,
      show: false
    });
    this.modal.on('shown.bs.modal', this.shown.bind(this));
    this.modal.on('hidden.bs.modal', this.reset.bind(this));
  },
  methods: {
    ...mapActions('profile', ['submitBackground']),
    shown() {},
    reset() {},
    show() {
      this.modal.modal('show');
    },
    hide() {
      this.modal.modal('hide');
    },
    onSelect(option) {
      const color = option.title;
      this.submitBackground({
        projectID: this.projectId,
        color
      }).then(() => {
        this.hide();
        window.location.reload();
      });
    },
    onCancel() {
      this.hide();
    }
  },
  computed: {
    options1() {
      return [{
        title: 'Regal Blue',
        text: 'Regal Blue',
        img: '/assets/img/backgroundcolors/Regal Blue.jpg'
      }, {
        title: 'Pale Blue',
        text: 'Pale Blue',
        img: '/assets/img/backgroundcolors/Pale Blue.jpg'
      }, {
        title: 'Aqua',
        text: 'Aqua',
        img: '/assets/img/backgroundcolors/Aqua.jpg'
      }, {
        title: 'Lavender',
        text: 'Lavender',
        img: '/assets/img/backgroundcolors/Lavender.jpg'
      }, {
        title: 'Pink',
        text: 'Pink',
        img: '/assets/img/backgroundcolors/Pink.jpg'
      }];
    },
    options2() {
      return [{
        title: 'Concrete Gray',
        text: 'Concrete Gray',
        img: '/assets/img/backgroundcolors/Concrete Gray.jpg'
      }, {
        title: 'Burgundy',
        text: 'Burgundy',
        img: '/assets/img/backgroundcolors/Burgundy.jpg'
      }, {
        title: 'Dark Blue (Seniors Only)',
        text: 'Dark Blue<br />(Seniors Only)',
        img: '/assets/img/backgroundcolors/Dark Blue_Seniors Only.jpg'
      }, {
        title: 'Thunder Gray (Seniors Only)',
        text: 'Thunder Gray<br />(Seniors Only)',
        img: '/assets/img/backgroundcolors/Thunder Gray_Seniors Only.jpg'
      }];
    }
  },
  components: {
    Multiselect
  }
};